<template>
  <div class="admin">
    <router-view></router-view>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "AdminMain",
  computed: {
    ...mapState("utente", ["status", "user"]),
  },
  created() {
    if (this.user.type !== 2) {
      this.$router.push({ name: "Home" });
    }
  },
};
</script>